import { IconButton, Menu } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
import { DOMAIN_CONFIG_OBJ } from "../../../../utils/axiosInstance";
import {  useAppSelector } from "../../../../reduxStore/hooks";
import { QBOOK_DOMAIN_VALUES } from "../../../../utils/constants/domainNameValues";
import { useLocation, useNavigate } from "react-router-dom";
import NavigationMenu from "../../muiNavigation";
import { RootState } from "../../../../reduxStore/store";

type Props = {};
const NavigationManager = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDark } = useAppSelector((state:RootState) => state.theme);
  const [headerMenuAnchorEl, setHeaderMenuAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const open = Boolean(headerMenuAnchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setHeaderMenuAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setHeaderMenuAnchorEl(null);
  };

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="navigation-menus">
      <div
        className="navigation-logo-container"
        onClick={() => handleClick()}
        cy-data="navigation-logo-container"
      >
        <img
          src={
            DOMAIN_CONFIG_OBJ.domainName === QBOOK_DOMAIN_VALUES.quera
              ? isDark
                ? DOMAIN_CONFIG_OBJ.darkThemeLogo
                : DOMAIN_CONFIG_OBJ.lightThemeLogo
              : DOMAIN_CONFIG_OBJ.simpleLogo
          }
          className={
            DOMAIN_CONFIG_OBJ.domainName !== QBOOK_DOMAIN_VALUES.quera
              ? "navigation-logo"
              : "navigation-logo-quera"
          }
          alt="navigation"
          cy-data="navigation-logo"
        />
        {DOMAIN_CONFIG_OBJ.domainName !== QBOOK_DOMAIN_VALUES.quera && (
          <span className="navigation-title">
            {DOMAIN_CONFIG_OBJ.domainName}
          </span>
        )}
      </div>
      {location.pathname.includes("learn") && (
        <>
          <div className="navigation-menu-container">
            <IconButton
              aria-label="more"
              id="header-nav-long-btn"
              aria-controls={open ? "header-nav-long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleMenuClick}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="header-nav-long-menu"
              anchorEl={headerMenuAnchorEl}
              open={open}
              onClose={handleMenuClose}
              PaperProps={{
                style: {
                  maxHeight: "100vh",
                  width: "20ch",
                },
              }}
            >
              <NavigationMenu />
            </Menu>
          </div>
        </>
      )}
    </div>
  );
};

export default NavigationManager;
